// extracted by mini-css-extract-plugin
export var header = "_c0-0";